/******************************************************************************************
 * * BULLET
 * ---------------------------------------------------------------------------------------
 * This component is used to display a bullet point inline with text.
 * ****************************************************************************************/

import React from 'react';
import { Box } from '@mui/material';

interface BulletProps {
  children: React.ReactNode;
  value: {
    bullet: {
      themeColor: 'primary.main' | 'secondary.main';
      size: string[];
      spacingLeft: string[];
      spacingRight: string[];
    };
  };
}

const Bullet = ({ children, value }: BulletProps) => {
  
  return (
    <Box
      component="span"
      ml={value.bullet?.spacingLeft ?? 'unset'}
      mr={value.bullet?.spacingRight ?? '10px'}
      sx={{
        backgroundColor: value.bullet?.themeColor ?? 'primary.main',
        width: value.bullet?.size ?? '10px',
        height: value.bullet?.size ?? '10px',
        display: 'inline-block',
        borderRadius: '50%',
      }}
    />
  );
};

export default Bullet;
